<template>
  <div>
    <div class="mt-10 max-w-6xl mx-auto">
      <ul
        role="list"
        class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
      >
        <li
          class="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200 cursor-pointer"
          v-for="(integration, index) of integrations"
          :key="index"
          @click="gotoIntegration(integration)"
        >
          <div class="flex-1 flex flex-col p-8">
            <img
              class="w-32 h-32 flex-shrink-0 mx-auto object-contain"
              :src="`https://configs.carthike.com/images/${integration.cover}`"
              alt=""
            />
            <h3 class="mt-6 text-gray-900 text-sm font-medium">
              {{ integration.name }}
            </h3>
            <dl class="mt-1 flex-grow flex flex-col justify-between">
              <dd class="text-gray-500 text-sm">
                {{ integration.category }}
              </dd>
            </dl>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      pageTitle: "Reviews",
      integrations: []
    };
  },
  created() {
    this.$store.dispatch("Integrations/getIntegrations").then(response => {
      this.integrations = response.integrations;
    });
  },
  methods: {
    gotoIntegration(integration) {
      const routeBySlug = {
        loox: { name: "ReviewsHome", params: { appName: "loox" } },
        judgeme: { name: "ReviewsHome", params: { appName: "judgeme" } },
        trustedreviews: {
          name: "ReviewsHome",
          params: { appName: "trustedreviews" }
        },
        googlereviews: {
          name: "ReviewsHome",
          params: { appName: "googlereviews" }
        }
      };

      const route = routeBySlug[integration.slug];
      if (!route) return;

      const store = this.$store.getters.getStore;
      if (store.plan === "free" || store.plan === "limited_free") {
        this.onIntegrationPaywallBlocked({ name: "Plan" });
        return;
      }

      this.$router.push(route);
    },
    onIntegrationPaywallBlocked(redirectRoute) {
      alert("please upgrade to paid plans for integrations");
      this.$router.push(redirectRoute);
    }
  }
};
</script>

<style lang="scss" scoped></style>
